var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaNoBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6702 14.9H9.03823L10.0582 9.10357H11.6903L10.6702 14.9ZM7.66533 9.10357L6.10949 13.0904L5.92539 12.2319L5.92555 12.2322L5.37643 9.62547C5.37643 9.62547 5.31003 9.10357 4.60228 9.10357H2.03018L2 9.20172C2 9.20172 2.78655 9.35305 3.70708 9.86425L5.12492 14.9001H6.82529L9.4217 9.10357H7.66533ZM20.5015 14.9H22L20.6935 9.10342H19.3816C18.7758 9.10342 18.6283 9.53539 18.6283 9.53539L16.1943 14.9H17.8955L18.2357 14.039H20.3104L20.5015 14.9ZM18.7057 12.8496L19.5632 10.6804L20.0456 12.8496H18.7057ZM16.3219 10.4975L16.5548 9.25273C16.5548 9.25273 15.8362 9 15.087 9C14.2772 9 12.354 9.32731 12.354 10.9189C12.354 12.4164 14.6112 12.435 14.6112 13.2216C14.6112 14.0081 12.5865 13.8672 11.9183 13.3712L11.6757 14.6727C11.6757 14.6727 12.4044 15 13.5178 15C14.6315 15 16.3115 14.4668 16.3115 13.0155C16.3115 11.5084 14.034 11.3681 14.034 10.7128C14.0342 10.0574 15.6236 10.1416 16.3219 10.4975Z",
    fill: "#2566AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12L5.44046 9.50045C5.44046 9.50045 5.3728 9 4.65163 9H2.03075L2 9.09411C2 9.09411 3.2597 9.32129 4.46797 10.1725C5.62327 10.986 6 12 6 12Z",
    fill: "#E6A540"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaNoBorder);
export default __webpack_public_path__ + "static/media/visa-no-border.325c3c76079208a4210bbec440fb02b1.svg";
export { ForwardRef as ReactComponent };